// Module
var code = "<html> <head></head> <body class=\"%experimentVersion%\" style=\"margin:0;padding:0\"> <div id=\"badge\"> <span class=\"icon\">♥</span> <span class=\"integer\">1</span> </div> </body> </html> ";
// Exports
export default code;